import React, { FunctionComponent } from 'react'
import { CurrentCompany, CurrentUser, Tabs } from '../types/intefaces'

export interface DashboardV2Flags {
  showBuyerSection: boolean
  showSupplierSection: boolean
  showAgreementsSection: boolean
  showTimereportsSection: boolean
  canTransitionTenders: boolean
}

export interface IRailsContext {
  i18nLocale?: string
  scheme?: string
  port?: string
  host: string
  post: string
  location: string
  href: string
  currentCompany: CurrentCompany
  currentUser: CurrentUser
  tabs: Tabs
  isBuyer: boolean
  isSupplier: boolean
  canCreateAgreements: boolean
  dashboardV2: DashboardV2Flags
  avropsplatsenLabel: boolean
  showPriceBarometerBanner: boolean
}

const buildUrl = (scheme: string, host: string, port: string) => {
  let baseUrl = `${scheme}://${host}`
  if (JSON.parse(port)) {
    baseUrl += `:${port}`
  }
  return baseUrl
}

const withContext =
  (WrappedComponent: FunctionComponent) =>
  (props: any, railsContext: IRailsContext) =>
  () => {
    const {
      i18nLocale,
      scheme,
      host,
      port,
      href,
      currentCompany,
      currentUser,
      tabs,
      isBuyer,
      isSupplier,
      canCreateAgreements,
      dashboardV2,
      avropsplatsenLabel,
      showPriceBarometerBanner,
    } = railsContext

    return (
      <WrappedComponent
        baseUrl={buildUrl(scheme, host, port)}
        href={href}
        language={i18nLocale}
        currentCompany={currentCompany}
        currentUser={currentUser}
        tabs={tabs}
        isBuyer={isBuyer}
        isSupplier={isSupplier}
        canCreateAgreements={canCreateAgreements}
        dashboardV2={dashboardV2}
        avropsplatsenLabel={avropsplatsenLabel}
        showPriceBarometerBanner={showPriceBarometerBanner}
        {...props}
      />
    )
  }

export default withContext
